import { render, staticRenderFns } from "./editToPerm.vue?vue&type=template&id=13ebcd16"
import script from "./editToPerm.vue?vue&type=script&lang=js"
export * from "./editToPerm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports